import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 42.52 42.52",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21.05 5.75c-6.42 0-11.64 5.23-11.64 11.65 0 9.2 9.91 18.03 10.33 18.4.36.32.83.49 1.31.49s.95-.18 1.31-.49c.42-.37 10.33-9.2 10.33-18.4 0-6.42-5.22-11.65-11.64-11.65Zm.01 28.54c-.39-.35-9.65-8.59-9.65-16.9 0-5.32 4.33-9.65 9.64-9.65s9.64 4.33 9.64 9.65c0 8.3-9.26 16.55-9.63 16.9Z" }, null, -1),
    _createElementVNode("path", { d: "M21.24 11.85c-2.61 0-4.73 2.12-4.73 4.73s2.12 4.73 4.73 4.73 4.73-2.12 4.73-4.73-2.12-4.73-4.73-4.73Zm0 7.46c-1.51 0-2.73-1.23-2.73-2.73s1.23-2.73 2.73-2.73 2.73 1.23 2.73 2.73-1.23 2.73-2.73 2.73Z" }, null, -1)
  ])))
}
export default { render: render }